/* eslint-disable
    default-case
*/
// TODO: This file was updated by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import produce from 'immer';
import reactUpdate from 'immutability-helper';
import _ from 'underscore';

import {assert, assertAndContinue} from 'Asserts';
import {EventConstants} from 'constants/EventConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import AppDispatcher from 'lib/Dispatcher';
import EntryUpdater from 'notebook/entries/EntryUpdater';
import {addComputedTagValuesToNote} from 'notebook/integrations/registry/RegistrationActionUtil';
import VersionedItemSubstore from 'notebook/store/VersionedItemSubstore';
import {createNoteRuntimeSnapshotWithEvaluation} from 'notebook/tables/TableStoreTransforms';
import BaseEntryStore from 'stores/BaseEntryStore';
import TrayTaskStore from 'tray/TrayTaskStore';
import APIUtil from 'util/APIUtil';
import EntryUtil from 'notebook/util/EntryUtil';
import * as logging from 'util/Logging';
import {ActionMethod} from 'constants/AnalyticsConstants';
import {removeQueryResolutionsForTableFromSnapshotInNote} from 'notebook/tables/excess/Resolver';
import {getUpdatedNoteWithValidationErrors} from 'notebook/tables/excess/ValidationErrorHandler';
import {FocusedTableViewMode} from 'notebook/tables/TableConstants';
import * as context from 'Context';
import * as Perf from 'performance/Perf';
import {distribution} from 'metrics/Metrics';
import {TableLimitUtils} from 'notebook/performance/tableLimitUtils';
import {trackUpdateStructuredTableMappingsEvent} from 'notebook/structured-tables/structured-table-mappings/StructuredTableMappingsAnalytics';
import {getProcessTaskInputRowIndexes} from 'notebook/structured-tables/structured-table-mappings/invokeStructuredTableMappings';
import performStructuredTableMappings from 'notebook/structured-tables/structured-table-mappings/performStructuredTableMappings';
import {StructuredTableKind} from 'notebook/structured-tables/StructuredTableConstants';
import getAllStructuredTablesInNote from 'notebook/structured-tables/util/getAllStructuredTablesInNote';
import {
  StructuredTableMappingsGlobalState,
  StructuredTableMappingsStateManager,
} from 'notebook/structured-tables/structured-table-mappings/StructuredTableMappingsState';
import TableUtil from 'notebook/tables/TableUtil';
import DocumentEditorLockUtil from 'realtime/util/DocumentEditorLockUtil';

export const EVALUATION_PERF_INTERVAL = 60 * 1000;

// Store for a collection of Entries
class EntryStore extends BaseEntryStore {
  constructor(dispatcher) {
    super(dispatcher);

    this.evaluatorPerfId =
      Perf.start(
        `entry_evaluation`,
        {enabled: true, getMetadata: () => ({})},
        {
          interval: EVALUATION_PERF_INTERVAL,
          aggregations: [Perf.Aggregation.COUNT, Perf.Aggregation.MEDIAN, Perf.Aggregation.MAX],
        }
      ) ?? '';
  }

  resetState() {
    this.entries = {};
    super.resetState();
  }

  postSanitizeItem(
    id,
    newEntry,
    oldEntry,
    {bumpVersion, performTableEvaluation = true, multidocTableOp, evalMetrics = null}
  ) {
    if (!performTableEvaluation) {
      return newEntry;
    }

    // We always set performTableEvaluation=true when we update structured table mappings on the entry,
    // so we can skip updating the table mapping global state if performTableEvaluation=false
    if (oldEntry?.structuredTableMappings !== newEntry?.structuredTableMappings) {
      StructuredTableMappingsGlobalState.updateState(
        id,
        StructuredTableMappingsStateManager.setStructuredTableMappings(newEntry.structuredTableMappings)
      );
    }
    const updater = this.makeEntryUpdater(id, {bumpVersion, multidocTableOp, evalMetrics});
    const startTime = Date.now();
    Perf.markStart(this.evaluatorPerfId);
    const result = updater.run(newEntry, oldEntry);
    Perf.markEnd(this.evaluatorPerfId);
    this.__logEvaluationTimeByCellCount(newEntry, startTime, Date.now());
    return result;
  }

  makeEntryUpdater(id, {bumpVersion, multidocTableOp, evalMetrics}) {
    return new EntryUpdater(
      id,
      () => this.getEntry(id),
      (entryVersion, asyncMultidocTableOp, asyncEvalMetrics) => {
        const evalOptions = {
          bumpVersion,
          multidocTableOp: asyncMultidocTableOp,
          evalMetrics: asyncEvalMetrics,
        };
        const EntryActions = require('actions/EntryActions').default;
        EntryActions.update(id, {$merge: entryVersion}, evalOptions);
      },
      {multidocTableOp, evalMetrics}
    );
  }

  createItemSubstore() {
    return new VersionedItemSubstore({
      options: {
        idKey: 'entryId',
        itemKey: 'entry',
        asyncItemLoad: true,
        sanitizeItem: EntryUtil.sanitizeEntry,
        postSanitizeItem: this.postSanitizeItem.bind(this),
        getItemParts(item) {
          return item.note.noteParts.map((itemPart) => ({
            itemPartId: itemPart.cid,
            itemPart,
          }));
        },
        postProcess(versionedEntry) {
          if (versionedEntry.entry != null) {
            const newEntry = EntryUtil.addTasksToEntry(versionedEntry.entry);
            return reactUpdate(versionedEntry, {entry: {$set: newEntry}});
          } else {
            return versionedEntry;
          }
        },
        invertPostProcess: EntryUtil.removeTasksFromEntry,
        prepareForStore: EntryUtil.prepareForStore,
        pickRevertableFields: EntryUtil.pickRevertableFields,
        doSave(id) {
          const EntryActions = require('actions/EntryActions').default;
          return EntryActions.save(id);
        },
        enableItemPartLevelSaving: true,
      },
      events: {
        item: {
          load: {
            init: EventConstants.ENTRY_OPEN,
            completed: EventConstants.ENTRY_OPEN_COMPLETED,
            failed: EventConstants.ENTRY_OPEN_FAILED,
          },
          close: EventConstants.ENTRY_CLOSE,
          dirty: EventConstants.ENTRY_INVALIDATE,
          rename: EventConstants.FILE_BROWSER_RENAME_FILE,
          resetToOpenVersion: EventConstants.ENTRY_RESET_TO_OPEN_VERSION,
          revert: EventConstants.ENTRY_REVERT,
          update: EventConstants.ENTRY_UPDATE,
          registerObjects: EventConstants.ENTRY_REGISTER_OBJECTS,
          save: {
            init: EventConstants.ENTRY_SAVE,
            completed: EventConstants.ENTRY_SAVE_COMPLETED,
            failed: EventConstants.ENTRY_SAVE_FAILED,
          },
          move: EventConstants.FILE_BROWSER_MOVE_FILES_COMPLETED,
        },
        version: {
          load: {
            init: EventConstants.ENTRY_LOAD_VERSION,
            completed: EventConstants.ENTRY_LOAD_VERSION_COMPLETED,
            failed: EventConstants.ENTRY_LOAD_VERSION_FAILED,
          },
        },
        versions: {
          fetch: {
            init: EventConstants.ENTRY_FETCH_VERSIONS,
            completed: EventConstants.ENTRY_FETCH_VERSIONS_COMPLETED,
            failed: EventConstants.ENTRY_FETCH_VERSIONS_FAILED,
          },
        },
        collab: {
          collabJoin: EventConstants.ENTRY_COLLAB_JOIN,
          collabLeave: EventConstants.ENTRY_COLLAB_LEAVE,
        },
      },
    });
  }

  hasEntry(id) {
    return Boolean(this.getEntry(id));
  }

  getNote(id) {
    return this.itemSubstore.getItemState(id).entry.note;
  }

  getEntry(id) {
    return __guard__(this.itemSubstore.getItemState(id), (x) => x.entry);
  }

  isLockedFromExternalChange(id) {
    return this.itemSubstore.isLockedFromExternalChange(id);
  }

  payloadHandler(action) {
    if (action.actionType === EventConstants.COMPUTED_TAGS_UPDATED_AFTER_REGISTRATION_ACTION) {
      const {entryId, fileSummariesById, provenanceUuid} = action;
      if (!this.inStore(entryId)) {
        return true;
      }

      const entry = this.itemSubstore.getItemState(entryId).entry;
      const newEntry = {
        ...entry,
        note: addComputedTagValuesToNote(entry.note, provenanceUuid, fileSummariesById),
      };
      this.itemSubstore.updateItem(entryId, newEntry, {bumpVersion: true});
      // Clear history to prevent undoing computed field updates
      this.itemSubstore._clearHistory(entryId);
      this.emitChange();
      return true;
    }

    if (action.actionType === EventConstants.EXCESS_DELETE_SNAPSHOTTED_RESOLUTIONS_FOR_TABLE) {
      const {itemId, provenanceUuid, tableOp, lookupConfigIds} = action;
      if (!this.inStore(itemId)) {
        return true;
      }

      const entry = this.itemSubstore.getItemState(itemId).entry;
      const newEntry = {
        ...entry,
        note: removeQueryResolutionsForTableFromSnapshotInNote(entry.note, provenanceUuid, lookupConfigIds),
      };

      this.itemSubstore.updateItem(itemId, newEntry, {
        bumpVersion: true,
        multidocTableOp: {[itemId]: tableOp},
      });
      this.emitChange();
      return true;
    }

    // send analytics for table mapping changes, if needed
    if (action.actionType === EventConstants.ENTRY_REVERT) {
      const {entryId, entry} = action;
      const updatedMappings = entry.structuredTableMappings;

      if (
        updatedMappings &&
        updatedMappings !== StructuredTableMappingsGlobalState.getState(entryId).structuredTableMappings
      ) {
        trackUpdateStructuredTableMappingsEvent(
          ActionMethod.REVERT_NOTE,
          entryId,
          false,
          updatedMappings,
          getAllStructuredTablesInNote(entry.note),
          null
        );
      }
    }
    // Reordering is always initiated by the view.
    // We are just keeping the store in sync with this action
    let shouldEmit = this.itemSubstore.handlePayload(action);
    switch (action.actionType) {
      case EventConstants.ENTRY_SAVE_COMPLETED: {
        // propagate any new note part provenance IDs to the store
        const {entryId, cidNotePartProvenanceIdMap, lock} = action;
        if (this.inStore(entryId)) {
          const entry = this.itemSubstore.getItemState(entryId).entry;
          const newEntry = produce(entry, (draft) => {
            draft.note.noteParts.forEach((notePart) => {
              if (
                cidNotePartProvenanceIdMap &&
                cidNotePartProvenanceIdMap[notePart.cid] != null &&
                notePart.provenanceId !== cidNotePartProvenanceIdMap[notePart.cid]
              ) {
                notePart.provenanceId = cidNotePartProvenanceIdMap[notePart.cid];
              }
            });
            draft.lock = lock;
          });
          this.itemSubstore.updateItem(entryId, newEntry, {
            bumpVersion: false,
            performTableEvaluation: false,
          });
        }
        shouldEmit = true;
        DocumentEditorLockUtil.releaseLocks([entryId]);
        break;
      }
      case EventConstants.ENTRY_GENERATE_SNAPSHOT: {
        const {entryId, evaluatedTables} = action;

        if (!this.inStore(entryId)) {
          // Abort snapshot generation if entry is not in store
          // We do not expect this to happen
          logging.warn(
            `Attempted to generate evaluation snapshot for ${entryId} but it was not in the store!`
          );
          return false;
        }

        const entry = this.itemSubstore.getItemState(entryId).entry;
        const snapshot = createNoteRuntimeSnapshotWithEvaluation(evaluatedTables);
        const newEntry = {
          ...entry,
          note: {
            ...entry.note,
            noteRuntimeSnapshot: snapshot,
          },
        };

        this.itemSubstore.updateItem(entryId, newEntry, {bumpVersion: true});
        shouldEmit = true;
        break;
      }

      case EventConstants.ENTRY_SERVER_SIDE_UPDATE: {
        const {entryId} = action;
        if (this.inStore(entryId)) {
          shouldEmit = true;
        }
        break;
      }

      case EventConstants.EXCESS_FORCE_EVALUATION: {
        const {fileId} = action;
        // If the entry isn't in the store anymore we can skip evaluation.
        if (!this.inStore(fileId)) {
          return true;
        }

        const entry = this.itemSubstore.getItemState(fileId).entry;

        const updater = this.makeEntryUpdater(fileId, {bumpVersion: false});
        Perf.markStart(this.evaluatorPerfId);
        context.using({forceExcessRevaluate: true}, this, () => updater.run(entry, entry));
        Perf.markEnd(this.evaluatorPerfId);

        shouldEmit = true;
        break;
      }

      case EventConstants.TRAY_TASK_UPDATE:
        AppDispatcher.waitFor([TrayTaskStore.dispatchIndex]);
        shouldEmit = true;
        break;

      case EventConstants.EXPORT_PATENTSAFE_STARTED: {
        const {fileId} = action;
        assert(APIUtil.apiIdToType(fileId) === ModelTypeConstants.ENTRY);
        const entry = this.getEntry(fileId);
        // eslint-disable-next-line no-restricted-syntax
        const thirdPartyStorageServiceData = _.extend({}, entry.thirdPartyStorageServiceData, {
          isSendingToPatentsafe: true,
        });
        this.itemSubstore.mergeItem(fileId, {thirdPartyStorageServiceData});
        shouldEmit = true;
        break;
      }

      case EventConstants.EXPORT_PATENTSAFE_COMPLETED: {
        const {fileId, item} = action;
        assert(APIUtil.apiIdToType(fileId) === ModelTypeConstants.ENTRY);
        // eslint-disable-next-line no-restricted-syntax
        const thirdPartyStorageServiceData = _.extend({}, item.thirdPartyStorageServiceData, {
          isSendingToPatentsafe: false,
        });
        this.itemSubstore.mergeItem(fileId, {thirdPartyStorageServiceData});
        shouldEmit = true;
        break;
      }

      case EventConstants.EXPORT_PATENTSAFE_FAILED: {
        const {fileId} = action;
        assert(APIUtil.apiIdToType(fileId) === ModelTypeConstants.ENTRY);
        const entry = this.getEntry(fileId);
        // eslint-disable-next-line no-restricted-syntax
        const thirdPartyStorageServiceData = _.extend({}, entry.thirdPartyStorageServiceData, {
          isSendingToPatentsafe: false,
        });
        this.itemSubstore.mergeItem(fileId, {thirdPartyStorageServiceData});
        shouldEmit = true;
        break;
      }

      case EventConstants.STRUCTURED_TABLE_INVOKE_MAPPINGS: {
        const {fileId, sourceTableProvenanceUuid, options} = action;
        if (!this.hasEntry(fileId)) {
          break;
        }
        const note = this.getNote(fileId);
        const tableMappingResult = performStructuredTableMappings(
          note,
          fileId,
          sourceTableProvenanceUuid,
          options
        );
        this.itemSubstore.mergeItem(
          fileId,
          {note: tableMappingResult.updatedNote},
          {
            bumpVersion: true,
            multidocTableOp:
              tableMappingResult.tableOp != null ? {[fileId]: tableMappingResult.tableOp} : undefined,
          }
        );
        shouldEmit = true;
        break;
      }

      case EventConstants.ENTRY_INVOKE_PROCESS_TASK_EXECUTION_TABLE_MAPPING: {
        const {entryId, taskIds} = action;
        const note = this.getNote(entryId);
        const structuredTables = getAllStructuredTablesInNote(note);
        const processTaskInputTable = structuredTables.find(
          (table) => table.kind === StructuredTableKind.PROCESS_TASK
        );
        if (!processTaskInputTable) {
          assertAndContinue(
            Boolean(processTaskInputTable),
            'No process task input table found in Workflow Execution Entry'
          );
          return true;
        }
        // check to see if mappings exist for the Process Task Input table
        if (
          StructuredTableMappingsStateManager.hasMappingsFromSourceTable(
            StructuredTableMappingsGlobalState.getState(entryId),
            processTaskInputTable.provenanceUuid
          )
        ) {
          const options = {
            sourceTableRowIndexes: getProcessTaskInputRowIndexes(processTaskInputTable, taskIds),
            analytics: {
              actionMethod: ActionMethod.CREATE_ENTRY,
            },
          };
          const tableMappingResult = performStructuredTableMappings(
            note,
            entryId,
            processTaskInputTable.provenanceUuid,
            options
          );
          this.itemSubstore.mergeItem(
            entryId,
            {note: tableMappingResult.updatedNote},
            {
              bumpVersion: true,
              multidocTableOp:
                tableMappingResult.tableOp != null ? {[entryId]: tableMappingResult.tableOp} : undefined,
            }
          );
          shouldEmit = true;
        }
        break;
      }

      case EventConstants.ENTRY_SET_FOCUSED_TABLE: {
        const {fileId, focusedTableProvenanceUuid, focusedTableViewMode} = action;
        if (!this.inStore(fileId)) {
          break;
        }
        this.itemSubstore.mergeItem(fileId, {
          focusedTableProvenanceUuid,
          focusedTableViewMode: focusedTableViewMode ?? FocusedTableViewMode.FULLSCREEN,
        });
        shouldEmit = true;
        break;
      }

      case EventConstants.STRUCTURED_TABLE_VALIDATION_ERRORS: {
        const {entryId, validationErrorResponse} = action;
        if (!this.inStore(entryId)) {
          break;
        }
        const entry = this.itemSubstore.getItemState(entryId).entry;
        const newNote = getUpdatedNoteWithValidationErrors(entry.note, validationErrorResponse);
        this.itemSubstore.mergeItem(entryId, {note: newNote}, {bumpVersion: true});
        shouldEmit = true;
        break;
      }
    }

    if (shouldEmit) {
      this.emitChange();
    }
    return true;
  }

  prepareForSave(id, entry) {
    const {cidIdMap} = this.itemSubstore.getItemState(id);
    const changedNoteParts = this.getUnsavedItemParts(id);
    return EntryUtil.prepareForSave(entry, cidIdMap, changedNoteParts);
  }

  __serverBootstrapItem(object) {
    const EntryActions = require('actions/EntryActions').default;
    const DataTableActions = require('notebook/data-tables/DataTableActions');
    this.itemSubstore.__serverBootstrapItem(object);
    const entry = this.getEntry(object.id);
    DataTableActions.fetchDataTablesValidationStatus(object.id, entry.note);
    EntryActions.dispatchNoteReferencesLoadedForEntry(object.id, object.item.noteReferences);
    EntryActions.dispatchBlobDetailsLoadedForEntry(object.id, object.item.blobDetails);
  }

  __logEvaluationTimeByCellCount(entry, startTime, endTime) {
    const tables = TableUtil.getTablesFromNote(entry.note);
    const {numCells} = TableLimitUtils.analyzeNotePerformance(tables);

    const evaluationTime = endTime - startTime;
    let evaluationTimeBucket = '';
    if (evaluationTime <= 30) {
      evaluationTimeBucket = '0-30ms';
    } else if (evaluationTime <= 100) {
      evaluationTimeBucket = '30-100ms';
    } else if (evaluationTime <= 1000) {
      evaluationTimeBucket = '100-1000ms';
    } else {
      evaluationTimeBucket = '1s+';
    }
    distribution('perf.entry_evaluation_by_cell_count', numCells, {
      evaluationTimeBucket,
    });
  }
}

const entryStore = new EntryStore(AppDispatcher);

export default entryStore;

function __guard__(value, transform) {
  return value != null ? transform(value) : undefined;
}
